import { render, staticRenderFns } from "./AsideCategories.vue?vue&type=template&id=396e5572&scoped=true&"
import script from "./AsideCategories.vue?vue&type=script&lang=js&"
export * from "./AsideCategories.vue?vue&type=script&lang=js&"
import style0 from "./AsideCategories.vue?vue&type=style&index=0&id=396e5572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e5572",
  null
  
)

export default component.exports